import { BookingSlot } from "../types";

const minutesOfTime = (time: string) => {
    const [hours, minutes] = time.substring(0, 5).split(":").map(Number);
    const totalMinutes = hours * 60 + minutes;
    return totalMinutes;
};

const weekDayOfDate = (dateKey: string) => {
    const [year, month, day] = dateKey.split("-").map(Number);
    const weekDay = new Date(year, month - 1, day).getDay();
    return weekDay;
};

// Single source of truth for the "date_HH:mm" slot key, shared by the bookings-index writer and
// the calendar lookups so the two can never desync.
export const slotKey = (dateKey: string, time: string) => {
    const key = `${dateKey}_${time.substring(0, 5)}`;
    return key;
};

// Attributes each booking to every canonical slot its [start, end) overlaps (D11 — off-grid
// bookings still consume the slots they physically cover).
export const buildBookingsIndex = (
    bookings: Array<BookingSlot>,
    canonicalTimesForWeekDay: (weekDay: number) => Array<string>,
    slotDurationMin: number
) => {
    const bookingsMap: Record<string, Array<BookingSlot>> = {};

    bookings.forEach((booking) => {
        const weekDay = weekDayOfDate(booking.date);
        const canonicalTimes = canonicalTimesForWeekDay(weekDay);
        const bookingStart = minutesOfTime(booking.time);
        const rawBookingEnd = booking.endDate === booking.date ? minutesOfTime(booking.endTime) : 24 * 60;
        const bookingEnd = rawBookingEnd > bookingStart ? rawBookingEnd : bookingStart + 1;

        canonicalTimes.forEach((canonicalTime) => {
            const slotStart = minutesOfTime(canonicalTime);
            const slotEnd = slotStart + slotDurationMin;
            const overlaps = bookingStart < slotEnd && bookingEnd > slotStart;

            if (overlaps) {
                const key = slotKey(booking.date, canonicalTime);
                if (!bookingsMap[key]) {
                    bookingsMap[key] = [];
                }
                bookingsMap[key].push(booking);
            }
        });
    });

    return bookingsMap;
};
